module.exports = __webpack_public_path__ + "static/media/nodejs color.54d0b0ec.svg";